import { LanguageEnum } from 'utils/constants';
import { useFetch } from 'utils/sdk';
import { IPrice } from 'utils/types';

export interface IUsePaymentMethodListParams {
  flightTicketProposalUUID: string;
}

export interface IPaymentMethod {
  id: number;
  method: string;
  label: Record<LanguageEnum, string>;
  provider: string;
  applied_fees: IPrice[];
  total_proposal_prices: IPrice[];
  supported_currencies: string[];
}

export const usePaymentMethods = ({ flightTicketProposalUUID }: IUsePaymentMethodListParams) => {
  return useFetch<IPaymentMethod[]>(`api/customer-facing/payment-methods/${flightTicketProposalUUID}/`);
};
